export const PricingData = [

  {
    id:1,
    plan_name:"嘗試看看",
    plan_details:"將您的需求告訴 AI，快速生成符合規範的法律文件，文件邏輯由經兆事務所的律師團隊打造",
    price:"50點",
    time:"每份合約",
    link:"/pricing",
    features:[
      "可使用於各種類型 AI 合約生成",
      "不滿意成果品質時，隨時可退款"
    ]
  },
  {
    id:2,
    plan_name:"專業使用",
    plan_details:"覺得不錯的話，可以一次購買點數，不需多次操作，並享受優惠價格",
    price:"500點",
    time:"NTD 400",
    link:"/pricing",
    features:[
      "有合約生成需求時，隨時使用",
      "購買即贈 AI 合約審閱功能"
    ]
  },
  {
    id:3,
    plan_name:"客製化需求",
    plan_details:"覺得 AI 無法完全達成您要的複雜需求，希望讓專業律師幫忙審核把關嗎？",
    price:"NTD 500",
    time:"30分鐘",
    link:"/pricing",
    features:[
      "律師幫您人工審閱生成合約正確性",
      "推薦在處理複雜或重要的商業文件時使用"
    ]
  },

];